import BaseService from './base.service'

export default class SchedulerService extends BaseService {
    get(tipoAgenda, fnSuccess, fnError) {
        return this.getApi().get(`/scheduler?tipoAgenda=${tipoAgenda}`)
            .then(response => fnSuccess(response))
            .catch(error => fnError(this.getMessageFromError(error, 'Error al obtener las citas del usuario')));
    }

    add(tipoAgenda, appointment, fnSuccess, fnError) {
        return this.getApi().post(`/scheduler?tipoAgenda=${tipoAgenda}`, appointment)
            .then(response => fnSuccess(response))
            .catch(error => fnError(this.getMessageFromError(error, 'Error al guardar la cita del usuario')));
    }

    edit(tipoAgenda, id, appointment, fnSuccess, fnError) {
        return this.getApi().put(`/scheduler?tipoAgenda=${tipoAgenda}&id=${id}`, appointment)
            .then(response => fnSuccess(response))
            .catch(error => fnError(this.getMessageFromError(error, 'Error al actualizar la cita del usuario')));
    }

    delete(tipoAgenda, id, fnSuccess, fnError) {
        return this.getApi().delete(`/scheduler?tipoAgenda=${tipoAgenda}&id=${id}`)
            .then(response => fnSuccess(response))
            .catch(error => fnError(this.getMessageFromError(error, 'Error al eliminar la cita del usuario')));
    }
}
